enum DynamicGeofencesContourType {
  Distance = 'distance',
  Time = 'time',
}

export default DynamicGeofencesContourType;
